<template>
  <v-form ref="form" >

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12">
        <v-autocomplete
          v-model="entry.itemId"
          v-bind="getObject('itemId')"
          label="Item"
          :items="availableItemsForConsumption"
          item-value="id"
          item-text="name"
          @input="selectItem"
          :hint="consumedItemAdditionalInfo(entry.item)"
          persistent-hint
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>{{consumedItemAdditionalInfo(data.item)}}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="12">
        <v-autocomplete
          :disabled="!entry.itemId || readOnly"
          v-model="entry.packagingId"
          v-bind="getObject('packagingId')"
          label="Embalagem"
          :items="packagingList"
          item-value="id"
          item-text="name"
          @input="selectPackaging"
          :loading="packagingListLoading"
          autocomplete="off"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="12" v-if="seedPlotOperation && entry.item && (entry.item.type == 'Seed' || (entry.item.type == 'Seedling' && seedPlotOperation.operationType.kind == 'seedling_sown') ) && loggedUser && loggedUser.account && loggedUser.account.hasSeedlingProducerBusinessActivity">
        <v-autocomplete
          :disabled="!entry.itemId || readOnly"
          v-model="entry.trayId"
          v-bind="getObject('trayId')"
          label="Bandeja"
          :items="trayList"
          item-value="id"
          item-text="name"
          @input="selectTray"
          :loading="trayListLoading"
          autocomplete="off"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="12">
        <v-autocomplete
          v-model="entry.storageId"
          v-bind="getObject('storageId')"
          label="Estoque"
          :items="stockList"
          item-value="id"
          item-text="name"
          @input="selectStock"
          :hint="(entry.storage && entry.item) ? 'Quantidade disponível: ' + numberToDecimal(entry.storage.availableQuantity) + ' ' + entry.packaging.unitName : '' "
          persistent-hint
          :loading="stockListLoading"
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>Quantidade disponível: {{numberToDecimal(data.item.availableQuantity)}} {{entry.item.unit.name}}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <ExitMovementItemLotsIndex
          v-if="hasLot"
          :lotItems="entry.exitMovementItemLotsAttributes"
          :packaging="entry.packaging"
          :inputData.sync="entry.exitMovementItemLotsAttributes"
          :itemLots="itemLots"
          :readOnly="readOnly"          
          :hasTableTitle="true"
          :addAndEdit="true"
          :seedPlotOperation="seedPlotOperation"
          :movementItem="entry"
        />
      </v-col>

      <v-col cols="12" sm="12">
        <MaskedTextField
          v-if="renderComponent"
          :inputData.sync="entry.packagingQuantity"
          mask-type="currency_10d"
          label="Quantidade de Embalagens"      
          @update:inputData="changePackagingQuantity"
          autocomplete="off"
          :disabled="hasLot || readOnly"
          :suffix="entry.packaging ? entry.packaging.text : ''"
          :key="packagingQuantityKey + 'packagingQuantity'"
        />        
      </v-col>

      <v-col cols="12" sm="12">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('quantity')"
          :inputData.sync="entry.quantity"
          mask-type="currency_10d"
          label="Quantidade"
          :suffix="entry.item ? entry.item.unit.name : ''"
          :disabled="!entry.storageId || readOnly || hasLot"
          autocomplete="off"
          :key="quantityKey + 'quantityKey'"
          @update:inputData="changeQuantity"
        />
      </v-col>

      <v-col cols="12" sm="12">
        <MaskedTextField
          v-if="renderComponent && !serviceProvision && !seedPlotOperation"
          :inputData.sync="applicationDose"
          mask-type="currency_10d"
          label="Dose de Aplicação"
          :disabled="!entry.itemId || readOnly"
          @update:inputData="changeApplicationDose"
          :key="applicationDoseKey + 'applicationDoseKey'"
          autocomplete="off"
          :suffix="entry.item ? entry.item.unit.name + '/ha' : ''"
          :hint="periodsAreaHint"
          persistent-hint
        />
        <!-- :suffix="entry.item ? entry.item.unit.name : ''" -->
      </v-col>

      <!-- hasCropLimit -->
      <v-col cols="12" sm="12" v-if="entry.item && entry.item.type == 'Seed' && loggedUser && loggedUser.account && loggedUser.account.hasSeedlingProducerBusinessActivity">
        <v-switch           
          v-model="entry.hasCropLimit"
          @change="changeCropLimit"
          inset 
          :label="entry.hasCropLimit ? 'Limita quantidade colhida' : 'Não limita quantidade colhida'"
          :disabled="readOnly"
          
        >
        </v-switch>
      </v-col>

      <v-col cols="12" sm="12" v-if="entry.hasCropLimit && entry.item && entry.item.type == 'Seed'  && entry.item.unit.name != 'UNID'">
        <MaskedTextField
          v-if="renderComponent && !serviceProvision"
          v-bind="getObject('packagingUnitQuantity')"
          :inputData.sync="entry.packagingUnitQuantity"
          mask-type="currency_10d"
          label="Qtd. de bandejas"
          :suffix="entry.tray ? entry.tray.text : ''"
          @update:inputData="changePackagingUnitQuantity"
          autocomplete="off"
          :disabled="readOnly || hasLot"
          :key="packagingUnitQuantityKey + 'packagingUnitQuantityKey'"
        />
      </v-col>

      <v-col cols="12" sm="12" v-if="entry.hasCropLimit && entry.item && entry.item.type == 'Seed'  && entry.item.unit.name != 'UNID'">
        <MaskedTextField
          v-if="renderComponent && !serviceProvision"
          v-bind="getObject('unitQuantity')"
          :inputData.sync="entry.unitQuantity"
          mask-type="currency_10d"
          label="Qtd. de Unidades Plantadas"          
          suffix="UNID"
          autocomplete="off"
          :disabled="readOnly || hasLot"
          :key="unitQuantityKey + 'unitQuantityKey'"
          @update:inputData="changeUnitQuantity"
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>

import MultiSelect from "@shared_components/multi_select.vue";
import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
import BaseUtil from "@shared_components/base_util.vue";
import ExitMovementItemLotsIndex from "@models/consumed_items/consumed_item_lots/index.vue";

export default {
  data() {
    return {
      loggedUser: {},
      entryAttributes: {},
      packagingListLoading: false,
      packagingList: [],
      trayListLoading: false,
      trayList: [],
      stockListLoading: false,
      stockList: [],
      renderComponent: true,
      applicationDose: 0,
      applicationDoseKey: 0,
      quantityKey: 0,
      packagingUnitQuantityKey: 0,
      unitQuantityKey: 0,
      packagingQuantityKey: 0,
      pageLoading: false,
      itemLots: [],
      hasLot: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    executionOperation: Object, // usado só para verificar qual o tipo que vai consumir esse item
    seedPlotOperation: Object, // usado só para o viveiro
    serviceProvision: Object, // usado só para verificar qual o tipo que vai consumir esse item
    isEdit: { // utilizado para definir se o form é de edição
      type: Boolean,
      default: false
    },
    originalEntry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MultiSelect: MultiSelect,
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
    ExitMovementItemLotsIndex: ExitMovementItemLotsIndex,
  },
  created() {
    this.getCurrentUser(user => {
      this.loggedUser = user;
    });

    this.entryAttributes = this.setupEntryAttributes(this.entry);
    // console.log("consumed item", this.entry.item)
    if (this.entry.item) {
      this.selectItem(false);
      this.updateApplicationDose();
    }
  },
  mounted() {
  },
  computed: {
    availableItemsForConsumption() {      
      return this.executionOperation ? this.extraData.accountContext.availableItemsForConsumptionInExecutionOperation : this.seedPlotOperation ? this.extraData.accountContext.availableItemsForConsumptionInSeedPlotOperation : this.extraData.accountContext.availableItemsForConsumptionInServiceProvision;
    },
    periodsAreaHint: function() {
      let periodsTotalArea = this.executionOperation.periods.map(item => item.area).reduce((a, b) => a + b, 0)
      return "Área total do(s) ciclo(s) selecionados é de " + this.numberToDecimal(periodsTotalArea) + " ha"
    }
  },
  watch: {
    "entry.exitMovementItemLotsAttributes": {
      handler: function(newValue, oldValue) {        
          // console.log("exit edited !!!");
          this.updateExitLots();
      },
      deep: true,
    },
  },
  methods: {
    consumedItemAdditionalInfo: function(item) {
      let info = ""
      if (item) {
        info = 'Unidade de Consumo: ' + item.unit.name + (item.brand ? ', Marca: ' + item.brand.name : '') + (item.typeText ? ', Tipo: ' + item.typeText : '')
      }
      return info;
    },
    changePackagingQuantity: function() {
      if(this.entry.packaging){
      // console.log("pk size",this.packaging.size);
        this.entry.quantity = _.round(this.entry.packagingQuantity * this.entry.packaging.size, 10);
        this.quantityKey++;
      }
      this.updateApplicationDose();
      // this.updateQuantity();
    },
    changeQuantity: function(){
      if(this.entry.packaging){
      // console.log("pk size",this.packaging.size);
        this.entry.packagingQuantity = _.round(this.entry.quantity / this.entry.packaging.size, 10);
        this.packagingQuantityKey++;
      }
      this.updateApplicationDose();
    },
    changePackagingUnitQuantity: function() {
      if(this.entry.tray){
      // console.log("pk size",this.packaging.size);
        this.entry.unitQuantity = _.round(this.entry.packagingUnitQuantity * this.entry.tray.size, 10);
        this.unitQuantityKey++;
      }
      // this.updateQuantity();
    },
    changeUnitQuantity: function(){
      if(this.entry.tray){
      // console.log("pk size",this.packaging.size);
        this.entry.packagingUnitQuantity = _.round(this.entry.unitQuantity / this.entry.tray.size, 10);
        this.packagingUnitQuantityKey++;
      }
    },
    changeApplicationDose: function() {
      if (this.applicationDose > 0) {
        let periodsTotalArea = this.executionOperation.periods.map(item => item.area).reduce((a, b) => a + b, 0)
        this.entry.quantity = _.round(this.applicationDose * periodsTotalArea, 10);
        this.quantityKey += 1;
        this.changeQuantity();
      }      
    },
    updateApplicationDose: function(){
      if (this.entry.quantity > 0 && !this.serviceProvision && !this.seedPlotOperation) {
        let periodsTotalArea = this.executionOperation.periods.map(item => item.area).reduce((a, b) => a + b, 0)
        this.applicationDose = _.round(this.entry.quantity / periodsTotalArea, 10);         
        this.applicationDoseKey += 1;
      }
      // if(this.entry.quantity > 0 && this.entry.packaging){
      //   this.entry.packagingQuantity = this.entry.quantity / this.entry.packaging.size;
      //   this.packagingQuantityKey+=1;
      // }
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    selectItem: function(clearPackagingAndStock=true) {
      // console.log("entry.item", this.entry.item);
      // console.log("entry", this.entry);
      if (this.entry.itemId) {
        // this.changeQuantity();
        // this.entry.packagingQuantity = 0;        
        this.entry.item = this.availableItemsForConsumption.find(obj => obj.id == this.entry.itemId);
        // this.clearFields();
        if (clearPackagingAndStock) {
          if(this.entry.exitMovementItemLotsAttributes){
            // console.log("limpando...");
            this.entry.exitMovementItemLotsAttributes.splice(0, this.entry.exitMovementItemLotsAttributes.length);
            this.hasLot = false;
          }
          this.entry.packagingId = null;
          this.entry.packaging = null;
          this.entry.storageId = null;
          this.entry.storage = null;
        }
        this.packagingListLoading = true;
        this.$apollo
          .query({
            query: AVAILABLE_PACKAGING_FOR_ITEM_QUERY,
            fetchPolicy: "no-cache",
            variables: {
              itemId: this.entry.itemId,
              exitMovementItemId: this.entry.id
            }
          })
          .then(response => {
            // console.log("response dos packaging", response);
            this.packagingList = response.data.accountContext.availableItemPackagingsForConsumption;
            let clearStock = false;
            if (this.packagingList.length == 1 && !this.entry.packagingId) {
              this.entry.packagingId = this.packagingList[0].id;
              clearStock = clearPackagingAndStock;
            }
            this.selectPackaging(clearStock);

            if (this.loggedUser && this.loggedUser.account && this.loggedUser.account.hasSeedlingProducerBusinessActivity && !this.entry.id) {
              this.entry.hasCropLimit = true;
              this.changeCropLimit();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.packagingListLoading = false));

          if(this.seedPlotOperation && (this.seedPlotOperation.operationType.kind == 'sowing' || this.seedPlotOperation.operationType.kind == 'seedling_sown')){
            this.loadTrays();
          }
      }
    },
    loadTrays: function() {
      // console.log("entry.item", this.entry.item);
      if (this.entry.itemId) {
        // this.clearFields();        
        this.trayListLoading = true;
        this.$apollo
          .query({
            query: AVAILABLE_TRAYS_FOR_ITEM_QUERY,
            fetchPolicy: "no-cache",
            variables: {
              itemId: this.entry.itemId
            }
          })
          .then(response => {
            // console.log("response dos packaging", response);
            this.trayList = response.data.accountContext.availableTraysForItem;
            // let clearStock = false;
            if (this.trayList.length == 1 && !this.entry.trayId) {
              this.entry.trayId = this.trayList[0].id;
              this.selectTray();
            }            
            if (this.loggedUser && this.loggedUser.account && this.loggedUser.account.hasSeedlingProducerBusinessActivity && !this.entry.id) {
              this.entry.hasCropLimit = true;
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.trayListLoading = false));
      }
    },
    changeCropLimit: function() {
      if (this.entry.hasCropLimit && this.entry.item && this.entry.item.type == 'Seed'  && this.entry.item.unit.name != 'UNID') {
        this.entryAttributes.unitQuantity.rules = [];
        this.entryAttributes.unitQuantity.rules.push(this.requiredRule);
        this.entryAttributes.unitQuantity.rules.push(this.minRequiredRule);
      } else {
        this.entry.unitQuantity = null;
      }
      this.$refs.form.resetValidation();
    },
    selectTray: function(){
      if (this.entry.trayId) {
        this.entry.tray = this.trayList.find(obj => obj.id == this.entry.trayId);
      }
      // console.log("tray", this.entry);
    },
    selectPackaging: function(clearStock=false) {
      if (this.entry.packagingId) {
        this.entry.packaging = this.packagingList.find(obj => obj.id == this.entry.packagingId);
        // this.clearFields();
        if (clearStock) {
          this.entry.storageId = null;
          this.entry.storage = null;
        }
        this.stockListLoading = true;
        this.$apollo
          .query({
            query: AVAILABLE_STOCK_FOR_ITEM_WITH_PACKAGING_QUERY,
            fetchPolicy: "no-cache",
            variables: {
              itemId: this.entry.itemId,
              packagingId: this.entry.packagingId,
              exitMovementItemId: this.entry.id
            }
          })
          .then(response => {
            // console.log("response dos stocks", response)
            this.stockList = response.data.accountContext.storagesWithAvailableItemAndPackagingForConsumption;
            // console.log("resp", response.data.accountContext.storagesWithAvailableItemAndPackagingForConsumption);
            if (this.stockList.length == 1 && !this.entry.storageId) {
              this.entry.storageId = this.stockList[0].id;
            }
            this.selectStock();
          })
          .catch(response => console.log(response))
          .finally(() =>{
            this.stockListLoading = false;
            this.changeQuantity();
          });
      }
    },
    selectStock: function() {
      if (this.entry.storageId) {
        this.entry.storage = this.stockList.find(obj => obj.id == this.entry.storageId);

        this.entryAttributes.quantity.rules = [];
        this.entryAttributes.quantity.rules.push(this.requiredRule);
        this.entryAttributes.quantity.rules.push(this.minRequiredRule);
        
        let availableQuantity = _.round(this.entry.storage.availableQuantity, 10);
        // usado para contabilizar a quantidade já salva no edit
        if (this.isEdit) {
          availableQuantity = _.round(availableQuantity + this.originalEntry.quantity, 10);
        }
        this.entryAttributes.quantity.rules.push(this.maxValueRule(availableQuantity));
        if (this.entry.quantity) {
          this.$refs.form.resetValidation();
        }
        this.availableLots();
      }
    }, 
    clearFields: function() {
      this.forceRerender(this);
    },    
    availableLots: function(){
      this.$apollo
          .query({
            query: AVAILABLE_LOTS_FOR_ITEM_QUERY,
            fetchPolicy: "no-cache",
            variables: {
              itemId: this.entry.itemId,
              packagingId: this.entry.packagingId,
              storageId: this.entry.storageId,
              movementItemLotId: this.entry.id,
            }
          })
          .then(response => {
            // console.log("response dos storages", response)
            this.itemLots = response.data.accountContext.availableLots;
            // console.log("lots", this.itemLots);            
            if(this.itemLots.length > 0){
              this.hasLot = this.itemLots[0].hasLot;
            }else{
              this.hasLot = false;
            }
            // console.log("available_lots", this.itemLots);
          })
          .catch(response => console.log(response))
          .finally(() => (this.availableQuantityLoading = false));
    },
    updateExitLots: function(){
      if(this.entry.packaging && this.entry.exitMovementItemLotsAttributes){
        // console.log("addExitLots");
        // this.entry.packagingQuantity = this.entry.exitMovementItemLotsAttributes.reduce((accumulator, object)=>{
        //   // console.log("packaging quantity:", object.packagingQuantity);
        //   return (accumulator) + (object.packagingQuantity);
        // }, 0);
        var reduced = 0;
        this.entry.exitMovementItemLotsAttributes.forEach((object)=>{
        // console.log("packaging quantity:", object.packagingQuantity);
          if (typeof object._destroy == 'undefined' || object._destroy == false){
            reduced+=parseFloat(object.packagingQuantity);
          }
        });
        this.entry.packagingQuantity = reduced;
        reduced = 0
        this.entry.exitMovementItemLotsAttributes.forEach((object)=>{
        // console.log("packaging quantity:", object.packagingQuantity);
          if (typeof object._destroy == 'undefined' || object._destroy == false){
            reduced+=parseFloat(object.packagingUnitQuantity);
          }
        });

        this.entry.packagingUnitQuantity = reduced;


        // this.entry.packagingUnitQuantity = this.entry.exitMovementItemLotsAttributes.reduce((accumulator, object)=>{          
        //   return (accumulator) + (object.packagingUnitQuantity);
        // }, 0);

        this.packagingQuantityKey += 1;
        this.changePackagingQuantity();
        this.packagingUnitQuantityKey += 1;
        this.changePackagingUnitQuantity();
      }
    },
  }
};

const AVAILABLE_PACKAGING_FOR_ITEM_QUERY = gql `
  query ($itemId: ID!, $exitMovementItemId: ID) {
    accountContext {
      availableItemPackagingsForConsumption(itemId: $itemId, exitMovementItemId: $exitMovementItemId){
        id
        name
        unitName
        size
        text
      }
    }
  }
`;

const AVAILABLE_TRAYS_FOR_ITEM_QUERY = gql `
  query ($itemId: ID!) {
    accountContext {
      availableTraysForItem(itemId: $itemId){
        id
        name
        size
        text
      }
    }
  }
`;

const AVAILABLE_STOCK_FOR_ITEM_WITH_PACKAGING_QUERY = gql `
  query ($itemId: ID!, $packagingId: ID!, $exitMovementItemId: ID) {
    accountContext {
      storagesWithAvailableItemAndPackagingForConsumption(itemId: $itemId, packagingId: $packagingId, exitMovementItemId: $exitMovementItemId){
        id
        name
        location
        availableQuantity
      }
    }
  }
`;

const AVAILABLE_LOTS_FOR_ITEM_QUERY = gql `
  query ($itemId: ID!, $packagingId: ID!, $storageId: ID!, $movementItemLotId: ID) {
    accountContext {
      availableLots(itemId: $itemId, packagingId: $packagingId, storageId: $storageId, movementItemLotId: $movementItemLotId)
    }
  }
`;

</script>

<style scoped></style>
